/*
Usage: Accordion.js
---
import stickyContent from './lib/stickyContent'

// 例：600pxを超えたら出現。footer 付近や最下部では退避
stickyContent(
  'footer', // 非表示にする要素のクラス名
  'sticky', // スクロール時に付与するクラス名のサフィックス
  600       // スクロール開始位置の閾値(px)
);
*/

const stickyContent = (hideClass, suffix = "", scrollHeight = 600) => {
  const body = document.body;
  const hide_el = hideClass ? document.querySelector("." + hideClass) : null;
  let ticking = false;

  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      // --- DOM reads (batch) ---
      const scrollY = window.scrollY;
      const hideRect = hide_el ? hide_el.getBoundingClientRect() : null;
      const atBottom = hideClass
        ? window.innerHeight + scrollY >= body.offsetHeight
        : false;

      // --- DOM writes (batch) ---
      body.classList.toggle(`--${suffix}-scroll-standby`, scrollY > 60);
      body.classList.toggle(
        `--${suffix}-scroll-ready`,
        scrollY > scrollHeight - 300,
      );
      body.classList.toggle(`--${suffix}-scroll-on`, scrollY > scrollHeight);

      if (scrollY > scrollHeight && hideRect) {
        if (hideRect.y <= hideRect.height) {
          body.classList.remove(`--${suffix}-scroll-on`);
          body.classList.add(`--${suffix}-scroll-out`);
        } else {
          body.classList.remove(`--${suffix}-scroll-out`);
        }
      }

      if (atBottom) {
        body.classList.remove(`--${suffix}-scroll-on`);
        body.classList.add(`--${suffix}-scroll-out`);
      }

      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });
};

export { stickyContent as default };
